export default __webpack_public_path__ + "static/media/52.354ab4b6.png";